// breakpoint
var $pc = 900;
const labels = {
  ja: {
    preorder: '予約する',
    outofstock: '在庫なし',
    addtocart: 'カートに入れる',
    quantity: '数量選択',
    comingsoon: '販売開始前の商品です',
  },
  en: {
    preorder: 'Pre-order',
    outofstock: 'Out of Stock',
    addtocart: 'Add to Cart',
    quantity: 'Select Quantity',
    comingsoon: 'This product is not yet on sale',
  }
};

const locale = Shopify.locale || 'ja';

function formatCardReleaseDate(date) {
  const isEn = String(locale).toLowerCase().indexOf('en') === 0;
  const pad = function (n) {
    return String(n).padStart(2, '0');
  };
  const formatted = date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate())
    + ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
  return isEn ? ('Release: ' + formatted) : ('発売日：' + formatted);
}

// headerFix
function headerFix() {
  $(window).on('scroll', function () {
    const scroll = $(this).scrollTop();
    if (scroll > 200) {
      $('body').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }
  });
}

// drawer
function drawer() {
  $('#js-global-header__humberger, .global-header__nav a, .js-drawer-close').on('click', function () {
    $('body').toggleClass('drawer-open');
  });
}

// pageScroll
function pageScroll() {
  $('a[href^="#"]').on('click', function () {
    if ($(this).hasClass('js-pagetop')) {
      $('html,body').animate({ scrollTop: 0 }, 600);
    } else {
      const $hash = $(this.hash);
      const $headerH = $('.global-header').outerHeight();
      $('html,body').animate({ scrollTop: $hash.offset().top - $headerH }, 300);
    }
    return false;
  });
}

// anchor
function anchor() {
  const $urlHash = location.hash;
  const $target = $($urlHash);
  if ($urlHash && $target.length) {
    const $headerH = $('.global-header').outerHeight();
    $('html,body').animate({ scrollTop: $target.offset().top - $headerH - 50 }, 300);
  }
}

// paging
function paging() {
  // 外部リンクは全てblank
  $('a[href^=http]').not('[href*="' + location.hostname + '"]').attr({ target: "_blank" });
}

// accordion
function accordion() {
  $('dl.js-accordion dt').on('click', function () {
    $(this).next().slideToggle(300);
    $(this).toggleClass('is_open');
  });

  $('.js-accordion').not('dl').on('click', function () {
    $(this).next().slideToggle(300);
    $(this).toggleClass('is_open');
  });

  $(function () {
    if (window.matchMedia('(max-width: 900px)').matches) {
      $('.js-dropdown-sp dt').on('click', function () {
        $(this).next().slideToggle(300);
        $(this).toggleClass('is_open');
        const targetElement = document.querySelectorAll('.global-footer__nav-global dl dd ul li');
        adjustFontSize(targetElement);
      });
    } else {
    }
  })
}

function storeMapAccordion() {
  $(document).on('click', '.js-store-map-toggle', function () {
    const $toggle = $(this);
    const $map = $toggle.nextAll('.section-product__store-detail__map').first();
    const mapSrc = $toggle.attr('data-map-src');
    const willOpen = !$toggle.hasClass('is_open');

    $toggle.toggleClass('is_open').attr('aria-expanded', willOpen);

    if (willOpen && mapSrc && $map.find('iframe').length === 0) {
      $map.html(
        '<iframe src="' + mapSrc.replace(/"/g, '&quot;') + '" width="600" height="240" style="border:0;" allowfullscreen loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>'
      );
    }

    $map.slideToggle(300);
  });
}

// inview
function inview() {
  $('section, .js-inview').on('inview', function () {
    $(this).addClass('is_inview');
  });
}

//loding
$(window).on('load', function () {
  $('body').addClass('loaded');
});

//　SPスクロールバー除外
function setHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// swiper
function slide() {
  // home kv
  if ($('body').hasClass('home')) {
    function silenceKvVideo(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function syncKvVideos(swiper) {
      if (!swiper || !swiper.slides) return;
      swiper.slides.forEach(function (slide) {
        const videos = slide.querySelectorAll('video');
        const visible = slide.classList.contains('swiper-slide-visible')
          || slide.classList.contains('swiper-slide-active');
        videos.forEach(function (video) {
          silenceKvVideo(video);
          if (visible) {
            const playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else {
            video.pause();
          }
        });
      });
    }

    const kvSlider = new Swiper('.js-kv-swiper', {
      loop: true,
      grabCursor: true,
      centeredSlides: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".js-swiper-pagination",
        type: "fraction"
      },
      navigation: {
        nextEl: '.js-swiper-button-next',
        prevEl: '.js-swiper-button-prev'
      },
      breakpoints: {
        320: { slidesPerView: 1.2, spaceBetween: 3 },
        700: { slidesPerView: 1.5, spaceBetween: 5 },
        1320: { slidesPerView: 2, spaceBetween: 10, },
        1728: { slidesPerView: 2.5, spaceBetween: 10, }
      },
      on: {
        init: function () {
          this.el.querySelectorAll('video').forEach(function (video) {
            silenceKvVideo(video);
            video.addEventListener('volumechange', function () {
              if (!video.muted || video.volume !== 0) silenceKvVideo(video);
            });
          });
          syncKvVideos(this);
        },
        slideChange: function () {
          syncKvVideos(this);
        },
        slideChangeTransitionEnd: function () {
          syncKvVideos(this);
        }
      }
    });
  }

  // home newarrivals
  $('.js-arrivals-swiper').each(function () {
    if (window.matchMedia('(max-width: 900px)').matches) {
      var itemCount = 2;
    } else {
      var itemCount = 3;
    }
    if ($(this).find('.swiper-slide').length > itemCount) {
      const swiperArrivals = new Swiper(this, {
        // Optional parameters
        grabCursor: true,
        loop: true,

        // If we need pagination
        pagination: {
          el: ".js-swiper-pagination",
          type: "fraction",
          clickable: "true",
        },

        // Navigation arrows
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        },

        breakpoints: {
          320: { slidesPerView: 2.2, spaceBetween: 5, },
          700: { slidesPerView: 3.5, spaceBetween: 10, },
          1320: { slidesPerView: 4.5, spaceBetween: 10, },
          1728: { slidesPerView: 5.5, spaceBetween: 10, }
        },
      });
    } else {
      $(this).find('.js-controller').remove();
    }
  });


  // home Coordinate
  if ($('body').hasClass('home')) {
    let coordinateSlide = null;

    const initSwiper = () => {
      coordinateSlide = new Swiper('.js-coordinate-swiper', {
        //  init: false,
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: ".js-swiper-pagination",
          type: "fraction"
        },
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 2.1,
            spaceBetween: 10,
            centeredSlides: false,
          },
          1024: { slidesPerView: 5, spaceBetween: 25, },
          1728: { slidesPerView: 6, spaceBetween: 30, }
        },
      });
    };

    initSwiper();

    // + タブ処理
    const tabs = $('.js-coordinate-tab');
    tabs.find('li').on('click', function () {
      tabs.find('li').removeClass('current');
      $(this).addClass('current');

      coordinateSlide.destroy(false, true);
      const target = $(this).attr('data-target');
      if (target == 'all') {
        $('.js-coordinate-swiper li').addClass('swiper-slide').show();
      } else {
        $('.js-coordinate-swiper li').each(function () {
          const tags = $(this).attr('data-tags');
          // console.log(tags);
          if (tags.indexOf(target) >= 0) {
            $(this).addClass('swiper-slide').show();
          } else {
            $(this).removeClass('swiper-slide').hide();
          }
        });
      }
      if ($('.js-coordinate-swiper .swiper-slide').length > 2) {
        $('.js-coordinate-swiper .js-controller').show();
        initSwiper();
      } else {
        $('.js-coordinate-swiper .js-controller').hide();
      }
    });
  }
}

// product slide
function productSlide() {
  // product page
  if ($('body').hasClass('product')) {
    const form = $('.AddToCartForm');
    const thumbnail = $('.js-thumb-swiper');
    if (thumbnail.find('.swiper-slide').length == 1) {
      thumbnail.hide();
      $('.section-product__images__arrow').remove();
      $('.section-product__images__main').css('opacity', 1);
    } else {
      // product thumbnail
      if (window.matchMedia('(max-width: 900px)').matches) {
        var thumbCount = 5;
      } else {
        var thumbCount = 6;
      }
      if (thumbnail.find('.swiper-slide').length < thumbCount) {
        thumbnail.find('.section-product__images__arrow').remove();
      }

      let initialIndex = 0;
      if (form.find('input[name="色"]').length) {
        // URLパラメータのカラーとチェックされているカラーが一致していない場合、チェックを入れる
        var values = new Object;
        url = location.search.substring(1).split('&');
        for (i = 0; url[i]; i++) {
          var key = url[i].split('=');
          values[key[0]] = key[1];
        }
        const decodeColor = decodeURI(values.color);
        console.log(decodeColor);
        form.find('input[value="' + decodeColor + '"]').prop('checked', true);
        //  slideChange();
        // チェックされているバリエーション画像をスライドの初期値に
        const imagesrc = form.find('input[name="色"]:checked').data('imagesrc');
        if (imagesrc != '') {
          $('.js-thumb-swiper img').each(function () {
            const thumbsrc = $(this).attr('src');
            if (thumbsrc.indexOf(imagesrc) > -1) {
              initialIndex = $('.js-thumb-swiper .swiper-slide').index($(this).parent('.swiper-slide'));
            }
          });
        }
      }
      console.log(initialIndex);

      const swiper_thumb = new Swiper('.js-thumb-swiper', {
        grabCursor: true,
        initialSlide: initialIndex,
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 5,
            spaceBetween: 5,
          },
          700: {
            slidesPerView: 6,
            spaceBetween: 5,
          }
        },
      });

      // product main
      const swiper_main = new Swiper('.js-main-swiper', {
        grabCursor: true,
        slidesPerView: 1,
        initialSlide: initialIndex,
        /*
        pagination: {
          el: ".js-swiper-pagination",
          type: "fraction"
        },
        */
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        },
        thumbs: {
          swiper: swiper_thumb,
        },
      });

      // 選択済みカラーの画像に切り替え
      function slideChange() {
        const imagesrc = form.find('input[name="色"]:checked').data('imagesrc');
        if (imagesrc != '') {
          $('.js-thumb-swiper img').each(function () {
            const thumbsrc = $(this).attr('src');
            if (thumbsrc.indexOf(imagesrc) > -1) {
              const index = $('.js-thumb-swiper .swiper-slide').index($(this).parent('.swiper-slide'));
              swiper_main.slideTo(index);
              swiper_thumb.slideTo(index);
            }
          });
        }
      }
      form.on('change', function () {
        slideChange();
      });
    }

    // related product
    const mediaQuery = window.matchMedia('(min-width: 900px)');
    let swiperRelated = null;
    const initSwiterRelarted = () => {
      swiperRelated = new Swiper('.section-related .js-related-swiper', {
        slidesPerView: 4,
        grabCursor: true,
        loop: true,
        spaceBetween: 27,
        pagination: {
          el: ".js-swiper-pagination",
          clickable: true,
          type: "fraction",
        },
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        },
        breakpoints: {
          700: { slidesPerView: 4, spaceBetween: 10, },
          1320: { slidesPerView: 5, spaceBetween: 10, },
          1728: { slidesPerView: 6, spaceBetween: 10, }
        },
      });
    }
    const checkBreakpoint = (e) => {
      if (e.matches) {
        initSwiterRelarted();
      } else if (swiperRelated) {
        swiperRelated.destroy(false, true);
      }
    }
    mediaQuery.addListener(checkBreakpoint);
    checkBreakpoint(mediaQuery);
  }
}


// cart
function cart() {
  // 数量変更
  $('.js-product-up').on('click', function () {
    const number = $(this).siblings('input[type="number"]');
    const value = parseInt(number.val());
    const maxvalue = number.attr('max');
    //  console.log(maxvalue);
    if (maxvalue) {
      // 上限あり
      if (maxvalue > value) {
        $(this).siblings('input[type="number"]').val(value + 1);
        $('button[name="update"]').trigger('click');
      }
    } else {
      // 上限なし
      $(this).siblings('input[type="number"]').val(value + 1);
      $('button[name="update"]').trigger('click');
    }
  });
  $('.js-product-down').on('click', function () {
    const number = $(this).siblings('input[type="number"]');
    const value = parseInt(number.val());
    if (value > 1) {
      $(this).siblings('input[type="number"]').val(value - 1);
      $('button[name="update"]').trigger('click');
    }
  });
}

// coordinate detail slide
function coordinateSlide() {
  const thumbnail = $('.js-thumb-swiper');

  // スライドが1つしかない場合は非表示＆矢印も削除
  if (thumbnail.find('.swiper-slide').length <= 1) {
    thumbnail.hide();
    $('.section-coordinate__images_arrow').remove();
    $('.section-coordinate__images_main').css('opacity', 1);
    return; // これで early return！ここで処理終わり！
  }

  // スライド数に応じて矢印表示切り替え
  const thumbCount = window.matchMedia('(max-width: 900px)').matches ? 5 : 6;
  if (thumbnail.find('.swiper-slide').length < thumbCount) {
    thumbnail.find('.section-coordinate__images_arrow').remove();
  }

  // ✅ .swiper-slide が存在することを確認してから Swiper 初期化！
  if (thumbnail.length && thumbnail.find('.swiper-slide').length > 0) {
    const swiper_thumb = new Swiper('.js-thumb-swiper', {
      navigation: {
        nextEl: '.js-swiper-button-next',
        prevEl: '.js-swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 5,
          spaceBetween: 5,
        },
        700: {
          slidesPerView: 6,
          spaceBetween: 5,
        },
      },
    });

    const swiper_main = new Swiper('.js-main-swiper', {
      grabCursor: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.js-swiper-button-next',
        prevEl: '.js-swiper-button-prev',
      },
      thumbs: {
        swiper: swiper_thumb,
      },
    });
  }
}

// coordinate popup
function coordinatePopup() {
  const anchor = $('.js-coordinatePopupAnchor');
  const popup = $('#js-coordinatePopup');
  const content = $('.js-coordinatePopup__content');
  const close = $('.js-coordinatePopup__close');

  content.hide();

  anchor.on('click', function () {
    const target = $(this).attr('data-target');
    popup.addClass('is_visible');
    $(target).show();

    const slide = $(target).find('.js-main-swiper');
    const thumbnail = $(target).find('.js-thumb-swiper');
    if (thumbnail.find('.swiper-slide').length == 1) {
      thumbnail.hide();
      $('.section-coordinate__images__arrow').remove();
      $('.section-coordinate__images__main').css('opacity', 1);
    } else {

      if (window.matchMedia('(max-width: 900px)').matches) {
        var thumbCount = 5;
      } else {
        var thumbCount = 6;
      }
      if (thumbnail.find('.swiper-slide').length < thumbCount) {
        thumbnail.find('.section-coordinate__images__arrow').remove();
      }

      // thumbnail
      const swiper_thumb = new Swiper(target + ' .js-thumb-swiper', {
        grabCursor: true,
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 5,
            spaceBetween: 5,
          },
          700: {
            slidesPerView: 6,
            spaceBetween: 5,
          }
        },
      });

      // coordinate main
      const swiper_main = new Swiper(target + ' .js-main-swiper', {
        grabCursor: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        },
        thumbs: {
          swiper: swiper_thumb,
        },
      });
    }
    return false;
  });

  close.on('click', function () {
    popup.removeClass('is_visible');
    //  swiper_main.destroy(false,true);
    //  swiper_thumb.destroy(false,true);
    content.hide();
  });
}

// collections-sort
function collectionsSort() {
  const href = $(location).attr('href');
  const url = href.replace(/\?.*$/, "");
  // pc
  $('.js-collections-sort-pc').find('select').each(function () {
    $(this).on('change', function () {
      if ($(this).attr('name') == 'sort') {
        var target = url + '?sort_by=' + $(this).val();
      } else {
        var target = $(this).val();
      }
      location.href = target;
    });
  });
  // sp
  const sort = $('.js-collections-sort-sp');
  const detail = $('.js-collections-sort-sp-detail');
  sort.find('select[name="sort"]').on('change', function () {
    var target = url + '?sort_by=' + $(this).val();
    location.href = target;
  });
  sort.find('.js-collections-sort-sp-open, .js-collections-sort-sp-close').on('click', function () {
    detail.toggleClass('is-visible');
    return false;
  });
  sort.find('.js-collections-sort-sp-submit').on('click', function () {
    const brand = sort.find('input[name="brands"]:checked').val();
    const category = sort.find('input[name="category"]:checked').val();
    if (brand.match(/all/) && category != '') {
      var target = '/collections/' + category;
    } else {
      var target = brand + '/' + category;
    }
    detail.removeClass('is-visible');
    location.href = target;
    return false;
  });
}

// password
function visiblePass() {
  $('.hide-password').click(function () {
    var $parent = $(this).parent('dd');
    $parent.toggleClass('visible');
    if ($parent.hasClass('visible')) {
      $parent.find('input').attr('type', 'text');
      $(this).attr('class', 'show-password');
    } else {
      $parent.find('input').attr('type', 'password');
      $(this).attr('class', 'hide-password');
    }
  });
}

function popup() {
  const popup = $('#js-password-popup');
  $('.js-password').on('click', function () {
    popup.fadeIn().addClass('is_visible');
  });
  $('.js-password-close').on('click', function () {
    popup.fadeOut().removeClass('is_visible');
  });
}

// searchform
function searchform() {
  $('.js-search-toggle').on('click', function () {
    //    console.log('click');
    $('.js-searchform').toggleClass('is_open');
  });
}

// more
function newarrivals() {
  if (window.matchMedia('(max-width: 900px)').matches) {
    $('#js-newarrivals').children('li:gt(19)').hide();
    $('.js-newarrivals-more').next('.btn-more').hide();
    $('.js-newarrivals-more').on('click', function () {
      $('#js-newarrivals').children('li').show();
      $(this).hide();
      $(this).next('.btn-more').show();
    });
  }
}
//トップページブランド制御
function homebrands() {
  if (window.matchMedia('(max-width: 900px)').matches) {
    var $hideLength = 3 * 10 - 1; //スマホ表示時表示させる個数です。 横の数 * 縦の数 - 1
  } else {
    var $hideLength = 4 * 10 - 1; //PC表示時表示させる個数です。 横の数 * 縦の数 - 1
  }
  if ($('#js-homebrands').children('li').length > $hideLength) {
    $('#js-homebrands').children('li:gt(' + $hideLength + ')').hide();
    $('.js-homebrands-more').on('click', function () {
      $('#js-homebrands').children('li').show();
      $(this).hide();
    });
  } else {
    $('.js-homebrands-more').hide();
  }
}

//フッタ文字サイズ自動調整(アルゴノーツ追記)
function adjustFontSize(elements) {
  for (element of elements) {
    let fontSize = parseFloat(window.getComputedStyle(element).fontSize);
    while (element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight) {
      fontSize -= 1;  // フォントサイズを少しずつ小さくする
      element.style.fontSize = fontSize + 'px';
      if (fontSize <= 5) break;  // 最小フォントサイズを制限
    }
  }
}


//フッタ文字サイズ自動調整(アルゴノーツ追記ここまで)




function ordermadeSlide() {
  const orderKv = new Swiper('.js-ordermade-swiper', {
    loop: true,
    grabCursor: true,
    centeredSlides: false,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".js-swiper-pagination",
      type: "fraction"
    },
    navigation: {
      nextEl: '.js-swiper-button-next',
      prevEl: '.js-swiper-button-prev'
    },
    breakpoints: {
      320: { slidesPerView: 1, spaceBetween: 10 },
      700: { slidesPerView: 2, spaceBetween: 20, },
      1728: { slidesPerView: 3, spaceBetween: 20, }
    },
  });
}


function bespokeBtn() {
  // 商品のボタンを取得する
  const bespokeBtn = document.querySelectorAll('.section-bespoke__btn');

  // 商品のボタンにイベントリスナーを設定する
  bespokeBtn.forEach(button => {
    button.addEventListener('click', () => {
      // クリックされた商品の data-product 属性値を取得する
      const product = button.getAttribute('data-product');

      // チェックボックスを取得する
      const checkboxes = document.querySelectorAll(`input[name="${product}"]`);

      // チェックボックスにチェックを入れる
      checkboxes.forEach(checkbox => {
        checkbox.checked = true;
      });

    });
  });
}

function bespokeSlide() {
  const thumbnail = $('.js-thumb-swiper');
  if (thumbnail.find('.swiper-slide').length == 1) {
    thumbnail.hide();
    $('.section-bespoke__images__arrow').remove();
    $('.section-bespoke__images__main').css('opacity', 1);
  } else {

    if (window.matchMedia('(max-width: 900px)').matches) {
      var thumbCount = 5;
    } else {
      var thumbCount = 6;
    }
    if (thumbnail.find('.swiper-slide').length < thumbCount) {
      thumbnail.find('.section-bespoke__images__arrow').remove();
    }

    // thumbnail
    const swiper_thumb = new Swiper('.js-thumb-swiper', {
      //  grabCursor: true,
      navigation: {
        nextEl: '.js-swiper-button-next',
        prevEl: '.js-swiper-button-prev'
      },
      breakpoints: {
        320: {
          slidesPerView: 5,
          spaceBetween: 5,
        },
        700: {
          slidesPerView: 6,
          spaceBetween: 5,
        }
      },
    });

    // ordermade-item main
    const swiper_main = new Swiper('.js-main-swiper', {
      grabCursor: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.js-swiper-button-next',
        prevEl: '.js-swiper-button-prev'
      },
      thumbs: {
        swiper: swiper_thumb,
      },
    });
  }
}

function bespokeList() {
  let bespokelist = null;

  const initSwiper = () => {
    bespokelist = new Swiper('.js-bespoke-swiper', {
      loop: true,
      grabCursor: true,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".js-swiper-pagination",
        type: "fraction"
      },
      navigation: {
        nextEl: '.js-swiper-button-next',
        prevEl: '.js-swiper-button-prev'
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
          centeredSlides: false,
        },
        1024: { slidesPerView: 5, spaceBetween: 14, },
        1728: { slidesPerView: 6, spaceBetween: 14, }
      },
    });
  };

  initSwiper();
}

// bespoke popup
function bespokePopup() {
  const anchor = $('.js-bespokePopupAnchor');
  const popup = $('#js-bespokePopup');
  const content = $('.js-bespokePopup__content');
  const close = $('.js-bespokePopup__close');

  content.hide();

  anchor.on('click', function () {
    const target = $(this).attr('data-target');
    popup.addClass('is_visible');
    $(target).show();

    const slide = $(target).find('.js-main-swiper');
    const thumbnail = $(target).find('.js-thumb-swiper');
    if (thumbnail.find('.swiper-slide').length == 1) {
      thumbnail.hide();
      $('.section-bespoke__images__arrow').remove();
      $('.section-bespoke__images__main').css('opacity', 1);
    } else {

      if (window.matchMedia('(max-width: 900px)').matches) {
        var thumbCount = 5;
      } else {
        var thumbCount = 6;
      }
      if (thumbnail.find('.swiper-slide').length < thumbCount) {
        thumbnail.find('.section-bespoke__images__arrow').remove();
      }

      // thumbnail
      const swiper_thumb = new Swiper(target + ' .js-thumb-swiper', {
        grabCursor: true,
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 5,
            spaceBetween: 5,
          },
          700: {
            slidesPerView: 6,
            spaceBetween: 5,
          }
        },
      });

      // bespoke main
      const swiper_main = new Swiper(target + ' .js-main-swiper', {
        grabCursor: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        },
        thumbs: {
          swiper: swiper_thumb,
        },
      });
    }
    return false;
  });

  close.on('click', function () {
    popup.removeClass('is_visible');
    //  swiper_main.destroy(false,true);
    //  swiper_thumb.destroy(false,true);
    content.hide();
  });
}

// soldout
function collectionsSoldout() {
  $('.js-list-products').find('li').each(function () {
    if ($(this).attr('data-color')) {
      const color = $(this).attr('data-color');
      if ($('[data-color-available="' + color + '"]').length > 0) {
       // console.log($(this).attr('data-color') + ':available');
      } else {
       // console.log($(this).attr('data-color') + ':soldout');
        $(this).addClass('is_soldout');
      }
    }
  });
}

// Group consecutive article images into 1–3 column rows
function articleImageRows() {
  const roots = document.querySelectorAll('.js-article-body');
  if (!roots.length) return;

  function isIgnorable(node) {
    return node.nodeType === Node.TEXT_NODE && !String(node.textContent || '').trim();
  }

  function isImageBlock(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
    const tag = node.tagName;
    if (tag === 'IMG') return true;
    if (tag === 'A' && node.querySelectorAll('img').length === 1) return true;
    if (tag === 'FIGURE') {
      return node.querySelectorAll('img').length === 1;
    }
    if (tag === 'P' || tag === 'DIV') {
      if (node.querySelectorAll('img').length !== 1) return false;
      if (node.querySelector('iframe, video, table, h1, h2, h3, h4, h5, ul, ol')) return false;
      if (String(node.textContent || '').replace(/\s/g, '').length > 0) return false;
      return true;
    }
    return false;
  }

  function wrapChunk(nodes, parent, beforeNode) {
    if (!nodes.length) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'article-image-row article-image-row--' + Math.min(nodes.length, 3);
    parent.insertBefore(wrapper, beforeNode);
    nodes.forEach(function (node) {
      wrapper.appendChild(node);
    });
  }

  function imageItemsFrom(el) {
    return Array.from(el.childNodes).reduce(function (items, node) {
      if (isIgnorable(node)) return items;
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') return items;
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'IMG') {
        items.push(node);
        return items;
      }
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'A' && node.querySelector('img')) {
        items.push(node);
        return items;
      }
      return items;
    }, []);
  }

  function isMultiImageContainer(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
    if (el.tagName !== 'P' && el.tagName !== 'DIV') return false;
    if (el.querySelector('iframe, video, table, h1, h2, h3, h4, h5, ul, ol')) return false;
    if (String(el.textContent || '').replace(/\s/g, '').length > 0) return false;
    return imageItemsFrom(el).length >= 2;
  }

  roots.forEach(function (root) {
    Array.from(root.children).forEach(function (el) {
      if (!isMultiImageContainer(el)) return;
      const items = imageItemsFrom(el);
      for (let i = 0; i < items.length; i += 3) {
        wrapChunk(items.slice(i, i + 3), root, el);
      }
      el.remove();
    });

    const groups = [];
    let current = [];
    Array.from(root.childNodes).forEach(function (node) {
      if (isIgnorable(node)) return;
      if (isImageBlock(node)) {
        current.push(node);
      } else if (current.length) {
        groups.push(current);
        current = [];
      }
    });
    if (current.length) groups.push(current);

    groups.forEach(function (group) {
      for (let i = 0; i < group.length; i += 3) {
        const chunk = group.slice(i, i + 3);
        wrapChunk(chunk, chunk[0].parentNode, chunk[0]);
      }
    });
  });
}

function applyListProductImageFit(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.js-card-image-fit').forEach(function (img) {
    const apply = function () {
      if (!img.naturalWidth || !img.naturalHeight) return;
      const isWiderThan45 = img.naturalWidth * 5 > img.naturalHeight * 4;
      img.classList.toggle('is-fit-contain', isWiderThan45);
      img.classList.toggle('is-fit-cover', !isWiderThan45);
    };
    if (img.complete) apply();
    else img.addEventListener('load', apply);
  });
}

function comingSoonBadges() {
  function expire() {
    const now = Date.now();
    document.querySelectorAll('.js-coming-soon-badge, .js-card-release-at').forEach(function (el) {
      const ts = Number(el.getAttribute('data-release-ts'));
      if (ts && now >= ts * 1000) el.remove();
    });
  }

  function localize() {
    document.querySelectorAll('.js-card-release-at').forEach(function (el) {
      const ts = Number(el.getAttribute('data-release-ts'));
      if (!ts) return;
      el.textContent = formatCardReleaseDate(new Date(ts * 1000));
    });
  }

  localize();
  expire();
  window.setInterval(expire, 15000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') expire();
  });
}

$(document).ready(function () {
  headerFix();
  drawer();
  paging();
  comingSoonBadges();
  applyListProductImageFit();
  setHeight();
  cart();
  popup();
  visiblePass();
  searchform();
  ordermadeSlide();
  bespokeList();
  bespokeBtn();
  bespokePopup();

  if ($('body').hasClass('home')) {
    slide();
    coordinatePopup();
    collectionsSoldout();

    if ($('#js-newarrivals').length) {
      newarrivals();
    }
    if ($('#js-homebrands').length) {
      homebrands();
    }
  } else {

  }
  if ($('body').hasClass('collection')) {
    collectionsSort();
    collectionsSoldout();
  }
  if ($('body').hasClass('product')) {
    productSlide();
    collectionsSoldout();
  }
  if ($('body').hasClass('page') && $('#js-bespokeSlide').length) {
    bespokeSlide();
  }
  if (!$('body').hasClass('home') && $('#js-coordinateSlide').length) {
    coordinateSlide();
  }
  articleImageRows();

});
$(window).on('load', function () {
  anchor();
  accordion();
  storeMapAccordion();
  pageScroll();
  inview();
});
$(window).resize(function () {
});
window.onpageshow = function (event) {
  if (event.persisted) {
    $('body').removeClass('paging').removeClass('drawer-open').addClass('loaded');
  }
};